/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EntityMediaItem } from '../../models/entity-media-item';
import { EnumMediaEntities } from '../../models/enum-media-entities';

export interface EntityMediaControllerDetach$Params {
  entity: EnumMediaEntities;
  entityId: number;
  mediaId: number;
}

export function entityMediaControllerDetach(http: HttpClient, rootUrl: string, params: EntityMediaControllerDetach$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>> {
  const rb = new RequestBuilder(rootUrl, entityMediaControllerDetach.PATH, 'delete');
  if (params) {
    rb.path('entity', params.entity, {});
    rb.path('entityId', params.entityId, {});
    rb.path('mediaId', params.mediaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EntityMediaItem;
      }>;
    })
  );
}

entityMediaControllerDetach.PATH = '/file-manager/{entity}/{entityId}/{mediaId}';
